import React from 'react';

const TikTokIcon = ({ size = 24, color = 'currentColor' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={color}
  >
    <path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm5.501 14.791c-.18.04-.362.06-.545.06-.327 0-.65-.08-.94-.23-.29-.15-.54-.37-.72-.64-.18-.27-.29-.59-.32-.93-.03-.34.04-.68.2-.98.16-.3.4-.55.68-.72.28-.17.6-.26.93-.26.18 0 .35.02.52.05v-3.5c-.17-.03-.34-.05-.52-.05-1.05 0-2.05.3-2.9.88-.85.58-1.52 1.39-1.98 2.36-.46.97-.69 2.03-.69 3.12 0 1.09.23 2.15.69 3.12.46.97 1.13 1.78 1.98 2.36.85.58 1.85.88 2.9.88.18 0 .36-.02.54-.06v-3.5zm-1.501-1.291c0 .2-.04.39-.12.57-.08.18-.19.34-.34.47-.15.13-.32.23-.52.29-.2.06-.41.09-.63.09-.22 0-.43-.03-.63-.09-.2-.06-.37-.16-.52-.29-.15-.13-.26-.29-.34-.47-.08-.18-.12-.37-.12-.57 0-.2.04-.39.12-.57.08-.18.19-.34.34-.47.15.13.32.23.52.29.2.06.41.09.63.09.22 0 .43.03.63.09.2.06.37.16.52.29.15.13.26.29.34.47.08.18.12.37.12.57z"/>
</svg>
);

export default TikTokIcon;
